import { render, staticRenderFns } from "./detalhesItem.vue?vue&type=template&id=afe9ee90"
import script from "./detalhesItem.ts?vue&type=script&lang=js&external"
export * from "./detalhesItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afe9ee90')) {
      api.createRecord('afe9ee90', component.options)
    } else {
      api.reload('afe9ee90', component.options)
    }
    module.hot.accept("./detalhesItem.vue?vue&type=template&id=afe9ee90", function () {
      api.rerender('afe9ee90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/detalhesCusto/detalhesItem.vue"
export default component.exports